function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.541 2.338v-.154c0-.486.485-.832.932-.655A6.917 6.917 0 0 1 14.933 8a6.918 6.918 0 0 1-4.46 6.471.694.694 0 0 1-.932-.655v-.154c0-.293.185-.547.462-.655A5.396 5.396 0 0 0 13.393 8a5.396 5.396 0 0 0-3.39-5.007.716.716 0 0 1-.462-.655zM1.067 6.459v3.082c0 .423.347.77.77.77h2.311l2.535 2.535c.485.485 1.317.138 1.317-.547V3.694c0-.686-.832-1.033-1.317-.547L4.148 5.689h-2.31a.773.773 0 0 0-.771.77zM11.467 8A3.467 3.467 0 0 0 9.54 4.895v6.202A3.447 3.447 0 0 0 11.467 8z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/audio.1ed239e6.svg";
export { SvgComponent as ReactComponent };